export const lightTheme = {
  body: "#BBAFDD",
  text: "#312D38",
  toggleBorder: "#BBAFDD",
  gradient: "linear-gradient(#512C78, #BBAFDD)",
  buttonBack: "#713AAB",
  buttonBorder: "#312D38",
};

export const darkTheme = {
  body: "#312D38",
  text: "#BBAFDD",
  toggleBorder: "#312D38",
  gradient: "linear-gradient(#312D38, #512C78)",
  buttonBack: "#512C78",
  buttonBorder: "#BBAFDD",
};
